import type { LimitRowView } from '@entities/prc';
import { Resource, cellText } from './styles';

/** Ресурс строки: «30 000–50 000», ниже средний; или текст книги («по мере отказа»). */
export function ResourceCell({ row }: { row: LimitRowView }) {
  const { from, to, avg } = row;
  if (from.numeric && from.value !== null) {
    const range =
      to.numeric && to.value !== null
        ? `${cellText(from, 0)}–${cellText(to, 0)}`
        : cellText(from, 0);
    return (
      <Resource>
        {range}
        {avg.numeric && avg.value !== null && <span className="sub">ср. {cellText(avg, 2)}</span>}
      </Resource>
    );
  }
  const text = [from.value, to.value].filter(Boolean).join(' – ');
  if (text) return <Resource data-text="true">{text}</Resource>;
  if (avg.numeric && avg.value !== null) return <Resource>ср. {cellText(avg, 2)}</Resource>;
  return <Resource>—</Resource>;
}
